import React, { useMemo, useEffect, useRef } from 'react';
import Select from '../Select';

const OrganizationRole = ({
    organizationRole,
    callback,
    roles = [],
    disabled = false,
    placeholder = "Organization Role",
    noItemSelectedTitle,
    id = "organization-role",
    error,
    className = ""
}) => {
    const isFirstRender = useRef(true);

    const options = useMemo(() => {
        if (!Array.isArray(roles)) return [];
        return roles.map((r) => {
            if (typeof r === 'string') {
                return { value: r, label: r };
            }
            const label = r.name || r.role_name || r.label || r.value || '';
            const value = r.name || r.role_name || r.value || r._id || r.id || label;
            return {
                value,
                label,
            };
        });
    }, [roles]);

    const currentValue = useMemo(() => {
        if (!organizationRole) return '';
        if (typeof organizationRole === 'object') {
            return organizationRole.name || organizationRole.role_name || organizationRole.value || '';
        }
        return organizationRole;
    }, [organizationRole]);

    // Initial sync callback
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (currentValue && typeof callback === 'function') {
                callback(currentValue);
            }
        }
    }, [currentValue, callback]);

    const handleChange = (e) => {
        const val = e?.target ? e.target.value : e;
        if (typeof callback === 'function') {
            callback(val);
        }
    };

    return (
        <Select
            id={id}
            options={options}
            value={currentValue}
            placeholder={placeholder || noItemSelectedTitle || "Organization Role"}
            disabled={disabled}
            error={error}
            className={className}
            onChange={handleChange}
        />
    );
};

export default OrganizationRole;
